import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import EventCard from '../EventCard';
import { getEventLink } from '../../helper/getEventLink';
import NewsItemHome from '../NewsItemHome';
import { wahoCardBg, wahoCardWithImg } from '../../common/cssclasses';
import { getFileName } from '../../helper/getFileName';
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function CustomSlider({
  items,
  type = 'events',
  handleProgramCardList,
  formatDay,
  formatYear,
  formatMonth,
  programDivActive,
  tabsClasses,
  setActivTab,
  activTab,
  categories
}) {
  const sliderRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [clickDisabled, setClickDisabled] = useState(false);
  const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setClickDisabled(false);
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    setClickDisabled(true);
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll speed
    sliderRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setTimeout(() => setIsDragging(false), 50); // Delay to prevent accidental clicks after dragging
  };

  const handleClick = (e) => {
    if (clickDisabled) {
      e.preventDefault();
      setClickDisabled(false);
    }
  };

  const [windowWidtht, setWindowWidth] = useState(window.innerWidth);
  const [itemWidth, setItemWidth] = useState('30%');

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth >= 769) {
        setItemWidth('30%');
      } else if (window.innerWidth >= 500) {
        setItemWidth('45%');
      } else if (window.innerWidth >= 350) {
        setItemWidth('90%');

      } else {
        setItemWidth('90%');

      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div
        ref={sliderRef}
        className='d-flex   w-100'
        style={{ overflowX: 'scroll', flexWrap: 'nowrap', cursor: isDragging ? 'grabbing' : 'grab', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseUp}
        onMouseUp={handleMouseUp}
      >
        {type == 'events' &&
          <>
            {items.map((item, index) => (

              <Link to={getEventLink(item.type, item.id)}
                key={index}
                className={`justRotate bg-white`}
                style={{ borderRadius: 10, width: itemWidth, aspectRatio: 1, minWidth: itemWidth, userSelect: 'none', pointerEvents: 'auto', marginLeft: currentLanguage == 'en' ? 0 : 10, marginRight: currentLanguage == 'en' ? 10 : 0 }}
                draggable='false'
                onClick={handleClick}
              >
                <EventCard key={item?.id} item={item} />

              </Link>
            ))}
          </>
        }
        {type == 'news' &&
          <>
            {items.map((item, index) => (

              <Link to={item.newsUrl} target={item.externalLink ? '_blank' : '_self'}
                key={index}
                className={` justRotate more_news_post_container`}
                style={{ width: itemWidth, aspectRatio: 1, minWidth: itemWidth, userSelect: 'none', pointerEvents: 'auto', marginLeft: currentLanguage == 'en' ? 0 : 10, marginRight: currentLanguage == 'en' ? 10 : 0 }}
                draggable='false'
                onClick={handleClick}
              >
                <NewsItemHome key={item?.id} item={item} windowWidtht={windowWidtht} />

              </Link>
            ))}
          </>
        }
        {type == 'days' &&
          items.map((itemProgram, index) => (
            <>
              <div
                className={tabsClasses} style={{ minWidth: 250 }}
                id={"second_most" + index}
                draggable='false'
                onClick={() => {
                  handleProgramCardList(
                    itemProgram.properties.dayKey, index
                  );
                }}
              >
                <span draggable='false' className={`${programDivActive === index ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{itemProgram.properties.programDay} {formatDay(
                  itemProgram.properties.programDate
                )} {formatMonth(
                  itemProgram.properties.programDate
                )} {formatYear(
                  itemProgram.properties.programDate
                )} </span>
                <div draggable='false' className="service_bar_underline" style={programDivActive === index ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
              </div>

            </>
          ))
        }
        {type == 'judges' &&
          categories.map((category, index) => (
            <>
              <div
                className={tabsClasses} style={{ minWidth: 250 }}
                id="second_most_used_services"
                onClick={() => setActivTab(parseInt(category?.value))}
              >

                <span className={`${activTab == parseInt(category?.value) ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{category?.text}</span>

                <div className="service_bar_underline" style={activTab == parseInt(category?.value) ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
              </div>

            </>
          ))
        }

        {type == 'wahopre' &&
          items.map((item, index) => (
            <div draggable={false} className={wahoCardWithImg}>
              <div draggable={false} className={wahoCardBg}>
                <div className='w-100 border-15 mb-form-group' style={{ overflow: 'hidden', maxHeight: 175, cursor: 'pointer' }}>
                  <img draggable={false}  src={`${MediaBaseURL}${item?.properties?.tourImage[0]?.url}`}
                    alt={getFileName(item?.properties?.tourImage[0]?.url)}
                    className='w-100 border-15' />
                </div>
                <div draggable={false} className='horseCardTitle mb-form-group'>
                  {item?.properties?.tourTitle}
                </div>
                <div className="whiteSpacer mb-form-group"></div>
                <div draggable={false} className='horseCardDescription fw-bold'>
                  {item?.properties?.tourTime}
                </div>

              </div>
            </div>
          ))
        }


      </div>
      <style>{`
        .d-flex::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </>
  );
}
